import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useStrip } from '../../plot/hooks/useStrip';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import {
  getRulerCursor,
  rulerPointsSelector,
  rulerRangeSelector,
} from '../selectors/ruler.selectors';
import { RulerLine } from './RulerLine';
import { RulerSquare } from './RulerSquare';
import * as rulerActions from '../actions/ruler.actions';

export const Ruler: React.FC = () => {
  const dispatch = useDispatch();
  const { xScale, height } = useStrip();
  const cursor = useSelector(getRulerCursor);
  const isRulerAnchored = useSelector(isToolActiveSelector(Tool.rulerAnchored));
  const points = useSelector(rulerPointsSelector);
  const [rulerStart, rulerEnd] = useSelector(rulerRangeSelector);

  return (
    <>
      {points.map((timestamp) => (
        <RulerLine
          key={timestamp}
          timestamp={xScale(timestamp)}
          height={height}
        />
      ))}
      {!isRulerAnchored && (
        <RulerSquare
          onset={rulerStart}
          offset={rulerEnd}
          setBoundary={(boundary) =>
            dispatch(rulerActions.setBoundary({ boundary }))
          }
          setMoving={(timestamp) =>
            dispatch(rulerActions.setMoving({ timestamp }))
          }
          cursor={cursor}
        />
      )}
    </>
  );
};
